import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
// require('../../themes/fonts')
const useStyles = makeStyles((theme) => {
  return {

    footerBar:{
      backgroundColor:'#ffffff',
      display:'flex',
      flexDirection:'column',
        flexGrow: 1,
        paddingLeft: theme.spacing(myTheme.padding.left+2),
        paddingRight: theme.spacing(myTheme.padding.right+3),
        paddingTop:theme.spacing(2.5),
        paddingBottom:theme.spacing(2.5),
        [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          paddingLeft: theme.spacing(myTheme.padding.left-9),
          paddingRight: theme.spacing(myTheme.padding.right-9),
        },
        [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
          paddingTop: theme.spacing(2),
          paddingBottom: theme.spacing(2),
          paddingLeft: theme.spacing(myTheme.padding.left-11),
          paddingRight: theme.spacing(myTheme.padding.right-11),
        },
    },
    vendorLogoMainContainer:{
      overflow: "auto",
      display: "flex", 
      flexDirection:'row',
      width:'100%',
      height:'100%',
      'scroll-behavior':'smooth'
      // border: 1,
      // borderColor:'#fafafa'
    },
    vendorLogoBox:{
      padding: 45,
      paddingTop:19,
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        padding:20,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        padding:15,
      }
    },
    newsletterInput:{
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width:160
      }
    },
    vendorLogoImg:{
      maxWidth:170,
      maxHeight:67
    },
    navDealProductsBtnBox:{
      margin:'auto',
      position:'sticky',
      marginRight:0
    },
    FooterLinksMainGrid:{
      marginTop:40,
      marginBottom:40
    },
    LinkOfFooter:{
      color:'white',
      //textDecoration:'none',
      "&:hover": {
          //backgroundColor: myTheme.palette.primary.dark,
          color: '#0000008a',
        }
    },
    newsletterBtn:{
      textTransform: "none",
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: 0,
      paddingLeft: 20,
      paddingRight: 20,
      borderBottomLeftRadius: 0,
      borderColor: myTheme.palette.secondary.light,
      paddingTop: 14.8,
      paddingBottom: 14.8,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
    },
    

  };
});

export default useStyles;
